const SET_BROKERCONNECT_DATA 			   = 'SET_BROKERCONNECT_DATA';
const SET_BROKERCONNECT_DATA_WITHOUT_SAVE  = 'SET_BROKERCONNECT_DATA_WITHOUT_SAVE';

export const BROKER_CONNECT_ACTION_TYPES = {
    SET_BROKERCONNECT_DATA,
    SET_BROKERCONNECT_DATA_WITHOUT_SAVE
};